<template>
  <div
    class="wrapper"
    style="
      padding-top: 0px;
      margin: 0px;
      width: 100%;
      height: 100%;
      background-color: #f6f6f6;
      max-width: 100%;
    "
  >
    <header class="show_header">
      <div>
        <button class="btn-sidebar" @click="$router.go(-1)">
          <img src="@/assets/img/arrow_back.svg" />
        </button>
      </div>

      <div class="header_title">
        <h3 class="upper title">ShowTimes</h3>
      </div>
      <div>
        <img
          src="@/assets/img/camera.svg"
          width="100%"
          class=""
          @click="scannerSection()"
        />
      </div>
      <div class="">
        <button class="btn-logout" @click="onLogout()">
          Logout
        </button>
      </div>
    </header>
    <!---Time & Date---->
    <section>
      <h3 class="upper date">{{ ShowDate }}</h3>
    </section>

    <!-- filter -->

    <section class="filter-section">
      <div class="filter-container">
        <!-- <label class="filter-label">Filter by Screen:</label> -->
        <select
          v-model="selectedScreenFilter"
          @change="onScreenFilterChange"
          class="screen-filter-select"
        >
          <option value="">All Screens ({{ availableScreens.length }})</option>
          <option
            v-for="screen in availableScreens"
            :key="screen.screen_id"
            :value="screen.screen_id"
          >
            {{ screen.screen_name }} ({{ getScreenShowCount(screen.screen_id) }}
            shows)
          </option>
        </select>

        <button
          v-if="selectedScreenFilter"
          @click="clearScreenFilter"
          class="clear-filter-btn"
          title="Clear Filter"
        >
          ✕
        </button>
      </div>

      <div class="filter-info" v-if="selectedScreenFilter">
        <!-- <span class="filter-info-text">
          Showing {{ filteredScheduleList.length }} movie(s) for
          <strong>{{ getSelectedScreenName() }}</strong>
        </span> -->
        <span class="filter-info-text">
          {{ filteredScheduleList.length }} Shows for
          <strong>{{ getSelectedScreenName() }}</strong>
        </span>
      </div>
    </section>

    <!--Shedule 1--->

    <section
      class="schedule_main"
      v-for="(schedule, schIndex) in filteredScheduleList"
      :key="schIndex"
    >
      <div class="d-flex align-items-center">
        <div class="movie-thumbnail-container">
          <img
            v-if="getMovieArtwork(schedule)"
            :src="getMovieArtwork(schedule)"
            :alt="schedule.original_movie_title"
            class="movie-thumbnail"
            @error="onImageError"
          />
          <div v-else class="movie-thumbnail-placeholder">
            <!-- <span>No Image</span> -->
            <!-- <img
              class="movie-thumbnail"
              src="@/assets/img/Placeholder_view_vector.svg"
            /> -->
            <img :src="placeholder" class="movie-thumbnail" />
          </div>
        </div>
        <div class="movie-details">
          <h3 class="title">
            {{ schedule.original_movie_title }}
            <span style="font-size: 12px; color: #818183">
              ({{
                moment(schedule.mrrdr_release_date, "YYYY-MM-DD").format(
                  "YYYY"
                )
              }})</span
            >
          </h3>
          <div
            class="d-flex align-items-center"
            style="gap: 10px; margin-top: 5px;margin-left: 5px;"
          >
            <div class="rating">{{ schedule.rating }}</div>
            <span>/</span>
            <div class="rating">{{ schedule.runtime }} min</div>
            <!-- <span>/</span> -->
            <!-- <div
              class="rating"
              v-if="schedule.screens && schedule.screens.length > 0"
            >
              {{ schedule.screens[0].version_full_name }}
            </div> -->
            <!-- <button
              class="language"
              v-if="schedule.screens && schedule.screens.length > 0"
            >
              {{ schedule.screens[0].version_full_name }}
            </button> -->
          </div>
        </div>
      </div>
      <section class="screening_section">
        <div class="shows-container">
          <div
            v-for="(showData, showIndex) in getAllShowsSortedByTime(schedule)"
            :key="`global-${showIndex}`"
            class="showtime-box"
          >
            <div class="showtime-row">
              <h2 class="screen_title">{{ showData.screen.screen_name }}</h2>

              <span class="show-timings">
                {{
                  showData.show.ss_start_show_time
                    ? moment(showData.show.ss_start_show_time, "HH:mm").format(
                        "h:mm A"
                      )
                    : ""
                }}
                -
                {{
                  showData.show.ss_end_show_time
                    ? moment(showData.show.ss_end_show_time, "HH:mm").format(
                        "h:mm A"
                      )
                    : ""
                }}
              </span>

              <div class="progress-bar-container">
                <div
                  class="progress-bar"
                  :style="{
                    '--progress': calculateOccupancyPercentage(showData.show)
                  }"
                >
                  <span class="progress-text">
                    {{ showData.show.booked_seats || 0 }}/{{
                      showData.show.screen_total_seats
                    }}
                  </span>
                </div>
              </div>
              <button
                @click="
                  onViewSeatLayout(schedule, showData.screen, showData.show)
                "
                class="seat-layout-btn"
                title="View Seat Layout"
              >
                <img
                  class="movie-thumbnail"
                  src="@/assets/img/seat_layout_icon.png"
                />
              </button>
            </div>
            <div
              class="d-flex align-items-center seat-types-row mt-1"
              style="gap: 8px;"
            >
              <div class="seat-type-item">{{ showData.show.mf_name }}</div>
              <!-- <span>/</span> -->
              <div
                class="seat-type-item"
                v-if="schedule.screens && schedule.screens.length > 0"
              >
                {{ schedule.screens[0].version_full_name }}
              </div>
            </div>
            <div
              class="seat-types-row mt-1"
              v-if="
                showData.show.seatTypes && showData.show.seatTypes.length > 0
              "
            >
              <div class="seat-types-flex-container">
                <div
                  v-for="(seatType, seatIndex) in showData.show.seatTypes"
                  :key="`seat-${seatIndex}`"
                  class="seat-type-item"
                >
                  <span class="seat-type-label">{{
                    seatType.seat_type_name
                  }}</span>
                  <span class="seat-type-dash">-</span>
                  <span class="seat-type-value">{{
                    seatType.booked_seats_of_type || 0
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
    <ShowSeatLayoutPopup
      modalId="seatLayoutView"
      :md_id="selectedShowDetails.md_id"
      :screen_id="selectedShowDetails.screen_id"
      :ss_id="selectedShowDetails.ss_id"
      :cinema_id="selectedShowDetails.cinema_id"
      :showDetails="selectedShowDetails.showDetails"
    />
  </div>
</template>

<script>
import BookingService from "@/services/BookingService";
import moment from "moment";
import ShowSeatLayoutPopup from "@/components/Partials/ShowSeatLayoutPopup.vue";
import placeholder from "@/assets/img/Placeholder_view_vector.svg";
export default {
  components: {
    ShowSeatLayoutPopup
  },
  name: "hello",
  data() {
    return {
      bookingCode: "",
      scheduleList: [],
      cinema_id: null,
      ShowDate: moment().format("DD.MMM.YYYY"),
      availableScreens: [],
      selectedScreenFilter: "",
      selectedShowDetails: {
        md_id: null,
        screen_id: null,
        ss_id: null,
        cinema_id: null,
        showDetails: {
          screen_name: "",
          movie_name: "",
          ss_actual_start_date: "",
          ss_start_show_time: ""
        }
      },
      placeholder
    };
  },
  computed: {
    filteredScheduleList() {
      if (!this.selectedScreenFilter) {
        return this.scheduleList;
      }

      return this.scheduleList.filter(schedule => {
        if (!schedule.screens || !Array.isArray(schedule.screens)) {
          return false;
        }

        return schedule.screens.some(
          screen =>
            screen.screen_id.toString() === this.selectedScreenFilter.toString()
        );
      });
    }
  },
  beforeMount() {
    this.cinema_id = window.localStorage.getItem("USERCINEINFO");
    this.getAllShowTimes();
  },
  methods: {
    moment,
    extractAvailableScreens() {
      const screenMap = new Map();

      this.scheduleList.forEach(schedule => {
        if (schedule.screens && Array.isArray(schedule.screens)) {
          schedule.screens.forEach(screen => {
            if (screen.screen_id && screen.screen_name) {
              screenMap.set(screen.screen_id.toString(), {
                screen_id: screen.screen_id,
                screen_name: screen.screen_name
              });
            }
          });
        }
      });

      this.availableScreens = Array.from(screenMap.values()).sort((a, b) =>
        a.screen_name.localeCompare(b.screen_name)
      );
    },
    getScreenShowCount(screenId) {
      let count = 0;
      this.scheduleList.forEach(schedule => {
        if (schedule.screens && Array.isArray(schedule.screens)) {
          const screen = schedule.screens.find(
            s => s.screen_id.toString() === screenId.toString()
          );
          if (screen && screen.shows) {
            screen.shows.forEach(showArray => {
              if (showArray.shows && Array.isArray(showArray.shows)) {
                count += showArray.shows.length;
              }
            });
          }
        }
      });
      return count;
    },

    getSelectedScreenName() {
      const screen = this.availableScreens.find(
        s => s.screen_id.toString() === this.selectedScreenFilter.toString()
      );
      return screen ? screen.screen_name : "";
    },

    onScreenFilterChange() {
      console.log("Screen filter changed to:", this.selectedScreenFilter);
    },

    clearScreenFilter() {
      this.selectedScreenFilter = "";
    },
    getFilteredShowsSortedByTime(schedule) {
      const allShowsWithScreenInfo = [];

      if (schedule.screens && Array.isArray(schedule.screens)) {
        schedule.screens.forEach(screen => {
          if (
            this.selectedScreenFilter &&
            screen.screen_id.toString() !== this.selectedScreenFilter.toString()
          ) {
            return;
          }

          if (screen.shows && Array.isArray(screen.shows)) {
            screen.shows.forEach(showArray => {
              if (showArray.shows && Array.isArray(showArray.shows)) {
                showArray.shows.forEach(show => {
                  allShowsWithScreenInfo.push({
                    show: show,
                    screen: screen
                  });
                });
              }
            });
          }
        });
      }

      return allShowsWithScreenInfo.sort((a, b) => {
        const timeA = a.show.ss_start_show_time || "00:00";
        const timeB = b.show.ss_start_show_time || "00:00";
        return timeA.localeCompare(timeB);
      });
    },

    getAllShowsSortedByTime(schedule) {
      return this.getFilteredShowsSortedByTime(schedule);
    },
    getMovieArtwork(schedule) {
      if (schedule.movie_content && schedule.movie_content.length > 0) {
        const contentWithArtwork = schedule.movie_content.find(
          content => content.artwork && content.artwork.trim() !== ""
        );
        return contentWithArtwork ? contentWithArtwork.artwork : null;
      }
      return null;
    },
    onImageError(event) {
      if (event.target) {
        event.target.src = this.placeholder;
      }
    },

    onViewSeatLayout(schedule, screen, show) {
      this.selectedShowDetails = {
        md_id: Number(show.md_id || schedule.movie_id),
        screen_id: Number(screen.screen_id || show.screen_id),
        ss_id: Number(show.ss_id),
        cinema_id: Number(this.cinema_id || show.cinema_id),
        showDetails: {
          screen_name: screen.screen_name || show.screen_name,
          movie_name: schedule.original_movie_title || show.movie_title,
          ss_actual_start_date: moment(show.ss_start_date).format("YYYY-MM-DD"),
          ss_start_show_time: show.ss_start_show_time
        }
      };
      this.$bvModal.show("seatLayoutView");
    },
    goToShow() {
      this.$router.push({
        name: "showtime",
        path: "/showtime"
      });
    },
    scannerSection() {
      this.$router.push({
        name: "qrCode",
        path: "/qrCode"
      });
    },
    onLogout() {
      window.localStorage.removeItem("JWT_TOKEN");
      window.localStorage.removeItem("USERCINEINFO");
      window.localStorage.clear();
      this.$cookie.delete("BRHSID");
      this.$router.push({
        name: "login"
      });
      return window.caches.keys();
    },
    onSubmitBookingCode() {
      if (this.bookingCode) {
        this.$router.push({
          name: "details",
          query: { qrcode: this.bookingCode }
        });
      } else {
        this.$toasted.show("Please Enter Booking Code");
      }
    },
    getAllShowTimes() {
      let loader = this.$loading.show();
      let payload = {
        start_date: moment().format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        cinema_id: this.cinema_id || null,
        operator: "qrcode"
      };
      BookingService.GetShowTimesList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Dates && data.Dates.length > 0) {
            this.ShowDate = moment(data.Dates[0]).format("DD.MMM.YYYY");
          } else {
            this.ShowDate = moment().format("DD.MMM.YYYY");
          }
          if (data && data.status && data.Records.length > 0) {
            this.scheduleList = data.Records.filter(x => x.showCount > 0);
            this.extractAvailableScreens();
            // console.log("this.scheduleList:", this.scheduleList);
          } else {
            this.$toasted.show(data.message || "No Records Found");
          }
        })
        .catch(err => {
          console.log("Error: Something Went Wrong", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    calculateOccupancyPercentage(show) {
      if (!show.screen_total_seats || show.screen_total_seats === 0) return 0;
      const booked = show.booked_seats || 0;
      const percentage = Math.round((booked / show.screen_total_seats) * 100);

      this.$nextTick(() => {
        const progressBar = this.$el.querySelector(".progress-bar");
        if (percentage < 30) {
          progressBar.classList.add("low");
          progressBar.classList.remove("medium", "high");
        } else if (percentage < 70) {
          progressBar.classList.add("medium");
          progressBar.classList.remove("low", "high");
        } else {
          progressBar.classList.add("high");
          progressBar.classList.remove("low", "medium");
        }
      });

      return percentage;
    },
    goToScan() {
      this.$router.push({
        name: "qrCode",
        path: "/qrCode"
      });
    }
  }
};
</script>
<style>
.showtime-box {
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.showtime-row {
  display: grid;
  grid-template-columns: auto auto 1fr auto;
  align-items: center;
  gap: 10px;
}

.show-timings {
  color: #555;
  font-weight: 500;
}

.show_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f6f6f6;
  padding: 15px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));
}
h2,
h3 {
  margin-bottom: 0px;
}
.title {
  font-size: 16px;
  color: black;
  font-weight: 700;
}
.upper {
  text-transform: uppercase;
}
.date {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  color: #818183;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.6px;
}
.schedule_main {
  /* background-color: white;
  padding: 15px; */
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 16px;
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.rating {
  color: black;
  background-color: #f6f6f6;
  padding: 5px;
  font-size: 10px;
  font-weight: bold;
}

.movie-thumbnail-container {
  margin-right: 12px;
  flex-shrink: 0;
}

.movie-thumbnail {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.movie-thumbnail-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background-color: #f0f0f0;
  border: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  color: #999;
  text-align: center;
}

.movie-details {
  flex: 1;
}

.screen_title {
  color: #032d6e;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
}
.screening_section {
  margin: 10px 0px;
}
.language {
  background-color: #4fadb5;
  color: white;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 10px;
  border: 1px solid #4fadb5;
  border-radius: 2px;
}

.schedule_main:not(:first-child) {
  margin-top: 10px;
}
.btn-logout {
  background-color: #032d6e;
  color: #fff;
  border-radius: 2px;
  /* position: absolute;
  right: 10px; */
  border: none;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 4px;
}
.data_table {
  margin-top: 5px;
}
.show-timings {
  color: #000000;
  font-size: 12px;
  font-weight: 400;
}
.progress-bar-container {
  width: 100px;
  margin: 0 10px;
}

.progress-bar {
  height: 24px;
  background-color: #f0f0f0 !important;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.progress-bar::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: calc(var(--progress) * 1%);
  background-color: #4fadb5 !important;
  transition: width 0.3s ease;
  border-radius: 12px 0 0 12px;
}

.progress-text {
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  color: #333;
  line-height: 24px;
  z-index: 1;
  text-shadow: 0 0 2px white;
}

.progress-bar.low::before {
  background-color: #4caf50;
}
.progress-bar.medium::before {
  background-color: #ffc107;
}
.progress-bar.high::before {
  background-color: #f44336;
}
.seat-types-flex-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.seat-type-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #ddd;
  font-size: 12px;
  transition: all 0.2s ease;
}

.seat-type-label {
  font-weight: 600;
  text-transform: capitalize;
  color: #333;
}

.seat-type-dash {
  color: #666;
  font-weight: 500;
}

.seat-type-value {
  font-weight: 700;
  color: #333;
}

.filter-section {
  background-color: white;
  padding: 15px;
  margin-bottom: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.filter-container {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.filter-label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
  min-width: fit-content;
}

.screen-filter-select {
  flex: 1;
  min-width: 200px;
  padding: 8px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  background-color: white;
  font-size: 14px;
  color: #333;
  transition: border-color 0.3s ease;
  outline: none;
}

.screen-filter-select:focus {
  border-color: #4fadb5;
  box-shadow: 0 0 0 3px rgba(79, 173, 181, 0.1);
}

.clear-filter-btn {
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.clear-filter-btn:hover {
  background-color: #d32f2f;
}

.filter-info {
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #e3f2fd;
  border-radius: 4px;
  border-left: 4px solid #4fadb5;
}

.filter-info-text {
  font-size: 13px;
  color: #333;
}

.no-results {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  background-color: white;
  border-radius: 8px;
  margin: 20px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.no-results-content {
  text-align: center;
  color: #666;
}

.no-results-content h3 {
  color: #333;
  margin-bottom: 10px;
}

.no-results-content p {
  margin-bottom: 20px;
  font-size: 14px;
}

.btn-clear-filter {
  background-color: #4fadb5;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.btn-clear-filter:hover {
  background-color: #3d8b91;
}
@media (max-width: 768px) {
  .filter-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .filter-label {
    align-self: flex-start;
  }

  .screen-filter-select {
    flex: 1;
    min-width: 200px;
    padding: 8px 12px;
    border: 2px solid #e0e0e0;
    border-radius: 6px;
    background-color: white;
    font-size: 14px;
    color: #333;
    transition: border-color 0.3s ease;
    outline: none;
  }

  .screen-filter-select:focus {
    border-color: #4fadb5;
    box-shadow: 0 0 0 3px rgba(79, 173, 181, 0.1);
  }

  .seat-types-flex-container {
    gap: 8px;
  }

  .seat-type-item {
    font-size: 11px;
    padding: 3px 6px;
    gap: 3px;
  }

  .seat-type-label {
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .filter-section {
    padding: 10px;
  }

  .progress-bar-container {
    width: 80px;
    margin: 5px auto;
  }
  .seat-types-flex-container {
    gap: 6px;
  }

  .seat-type-item {
    font-size: 10px;
    padding: 2px 4px;
    gap: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShowTime.vue